import React from 'react';
import { marked } from 'marked';
import DOMPurify from 'dompurify';
import './SoulmateResult.css';

const SoulmateResult = ({ result, imageUrl, onReset }) => {
  // Configure marked for better formatting
  marked.setOptions({
    breaks: true, // Convert line breaks to <br>
    gfm: true, // GitHub Flavored Markdown
  });

  // Convert markdown to HTML and sanitize it
  const createMarkup = (text) => {
    const rawMarkup = marked(text);
    return {
      __html: DOMPurify.sanitize(rawMarkup, {
        ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'ul', 'ol', 'li', 'blockquote', 'code', 'pre'],
        ALLOWED_ATTR: []
      })
    };
  };

  // Split the result into paragraphs to insert image after first paragraph
  const paragraphs = result.split('\n\n');
  const firstParagraph = paragraphs[0] || '';
  const remainingText = paragraphs.slice(1).join('\n\n');

  return (
    <div className="soulmate-result-container">
      <div className="result-header">
        <h2>✨ Your Soulmate Revealed</h2>
        <button onClick={onReset} className="new-reading-button">
          New Reading
        </button>
      </div>
      
      <div className="result-content">
        <div className="result-text markdown-content">
          {/* First paragraph */}
          <div dangerouslySetInnerHTML={createMarkup(firstParagraph)} />
          
          {/* Image after first paragraph */}
          {imageUrl && (
            <div className="soulmate-image-container">
              <img 
                src={imageUrl} 
                alt="Your soulmate as envisioned by the stars" 
                className="soulmate-image"
                onError={(e) => {
                  e.target.style.display = 'none';
                  console.error('Failed to load soulmate image');
                }}
              />
              <p className="image-caption">
                ✨ A cosmic vision of your destined love ✨
              </p>
            </div>
          )}
          
          {/* Remaining text */}
          {remainingText && (
            <div dangerouslySetInnerHTML={createMarkup(remainingText)} />
          )}
        </div>
      </div>
      
      <div className="result-footer">
        <p className="mystical-note">
          ⭐ The stars have spoken. May this cosmic guidance illuminate your path to love. ⭐
        </p>
      </div>
    </div>
  );
};

export default SoulmateResult;